import Button from "react-bootstrap/Button";
import React from "react";

const BackToHomePageButtonComponent = () => {
    return (
        <Button variant="success" onClick={() => window.location.replace("/")} style={{marginTop: "20px"}}>Úvodná stránka</Button>
    );
}

export default BackToHomePageButtonComponent;